import { FormHelperTextClassKey, StyleRules } from '@material-ui/core';

const MuiFormHelperText: Partial<StyleRules<FormHelperTextClassKey, {}>> = {
  root: {
    // Guinda para el feedback de validacion (--ds-color-error-700). Ademas de ser
    // la preferencia de diseno, da 7.88:1 de contraste sobre blanco contra los
    // 3.36:1 del rojo vivo, que no alcanza AA para texto normal.
    '&.Mui-error': {
      color: 'var(--ds-color-error-700)',
    },
  },
};

export default MuiFormHelperText;
